import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/modern/components/ui/alert-dialog";
import { Trash2 } from "lucide-react";

interface DeleteContextDialogProps {
  open: boolean;
  contextName: string | null;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DeleteContextDialog = ({
  open,
  contextName,
  onConfirm,
  onCancel,
}: DeleteContextDialogProps) => (
  <AlertDialog open={open} onOpenChange={(v) => !v && onCancel()}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-destructive/10">
            <Trash2 className="h-4 w-4 text-destructive" />
          </div>
          Delete context
        </AlertDialogTitle>
        <AlertDialogDescription className="mt-2 leading-relaxed">
          Are you sure you want to delete{" "}
          <span className="font-medium text-foreground">
            {contextName ?? "this context"}
          </span>
          ? This will permanently remove all groups and statements within it. This action cannot be undone.
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel onClick={onCancel}>Cancel</AlertDialogCancel>
        <AlertDialogAction
          onClick={onConfirm}
          className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
        >
          Delete context
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
